import { lazy } from 'react';
import { Route } from 'react-router-dom';

const CreateSchoolPage = lazy(() =>
  import('./pages/CreateSchoolPage').then(m => ({ default: m.CreateSchoolPage }))
);

/** Mounted inside <RequireAuth> but OUTSIDE the app shell (full-page flow). */
export const schoolRoutes = (
  <Route path="/onboarding/create-school" element={<CreateSchoolPage />} />
);
